var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2194 11.4152L9.9694 4.93519C10.1101 4.80012 10.301 4.72418 10.5 4.72418C10.699 4.72418 10.8899 4.80012 11.0306 4.93519C11.1714 5.07026 11.2504 5.25353 11.2504 5.44457C11.2504 5.6357 11.1714 5.81887 11.0306 5.95404L5.5603 11.2046L20.25 11.2046C20.4489 11.2046 20.6397 11.2805 20.7803 11.4155C20.921 11.5506 21 11.7336 21 11.9246C21 12.1155 20.921 12.2987 20.7803 12.4338C20.6397 12.5687 20.4489 12.6446 20.25 12.6446L5.5603 12.6446L11.0306 17.8952C11.1714 18.0303 11.2504 18.2135 11.2504 18.4046C11.2504 18.5957 11.1714 18.7789 11.0306 18.914C10.8899 19.0491 10.699 19.125 10.5 19.125C10.301 19.125 10.1101 19.0491 9.9694 18.914L3.2194 12.434C3.1496 12.3671 3.0943 12.2877 3.0566 12.2003C3.0188 12.1129 2.9994 12.0192 2.9994 11.9246C2.9994 11.83 3.0188 11.7363 3.0566 11.6489C3.0943 11.5615 3.1496 11.4821 3.2194 11.4152Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/_arrow-left.92a0dc3eb67643619faee00f6d72ea3e.svg";
export { ForwardRef as ReactComponent };